module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page-w960.78580cd2.jpg";